import React from "react";
function gerenciador(){
   return(
       <div>
       Indisponivel
       </div>
   )
}

export default gerenciador;